import {
  FieldSelectMulti as LookerSelectMulti,
  type FieldSelectMultiProps as LookerSelectProps,
} from '@looker/components';

import { cls } from '@/utils/cls';

import style from './styles.module.scss';

export type FieldSelectMultiProps = { limit?: number } & LookerSelectProps;

export function FieldSelectMulti({
  className,
  ...props
}: FieldSelectMultiProps) {
  return (
    <LookerSelectMulti
      className={cls(
        style.fieldSelectMulti,
        { [style.value]: props.values && props.values.length > 0 },
        className,
      )}
      {...props}
    />
  );
}
